import React, { Component } from 'react';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonSmallText from '../../../common-components/common-small-text';

const advices = [
    {
        text: 'Не останавливайтесь на одних и тех же рекламных каналах трафика или типах кампаний.',
        number: '01',
    },
    {
        text: 'Постоянно генерируйте и тестируйте новые гипотезы.',
        number: '02',
    },
    {
        text: 'Четко определите потребности целевой аудитории и соотнесите их с УТП продукта и геолокацией.',
        number: '03',
    },
    {
        text: 'Настройте системы аналитики.',
        number: '04',
    },
];

class Advice extends Component {
    render() {
        return (
            <div className="advice">
                <div className="advice__inner">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={0}
                        animateOnce={true}
                        duration={1}
                    >
                        <CommonSmallTitle className="advice__title">
                            <span className="advice__title advice__title--color">
                                4&nbsp;универсальных совета
                            </span>{' '}
                            для увеличения продаж в&nbsp;высококонкурентных нишах:
                        </CommonSmallTitle>
                    </ScrollAnimation>
                    <div className="advice__wrapper">
                        <div className="advice__list">
                            {advices.map(advice => (
                                <ScrollAnimation
                                    animateIn="fadeInUp"
                                    offset={0}
                                    animateOnce={true}
                                    duration={1}
                                    className="advice__item"
                                    key={advice.number}
                                >
                                    <div className="advice__number">{advice.number}.</div>
                                    <CommonSmallText className="advice__text">
                                        {advice.text}
                                    </CommonSmallText>
                                </ScrollAnimation>
                            ))}
                        </div>
                        <ScrollAnimation
                            animateIn="zoomIn"
                            offset={0}
                            animateOnce={true}
                            duration={1.2}
                        >
                            <img
                                className="advice__img"
                                src="/images/pic/bonum/advice.png"
                                alt="advice"
                                loading="lazy"
                            />
                        </ScrollAnimation>
                    </div>
                </div>
            </div>
        );
    }
}

export default Advice;
